import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-st-loader-svg',
  imports: [],
  templateUrl: './st-loader-svg.component.html',
  styleUrl: './st-loader-svg.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class StLoaderSvgComponent {
  @Input() width: number = 48;
  @Input() height: number = 48;
  @Input() bg: string = 'var(--neutral-500)';
  @Input() dark: string = 'var(--neutral-900)';
  @Input() accent: string = 'var(--neutral-700)';
  @Input() icon: string = 'var(--neutral-500)';
}
